// Grade K Technology Applications Questions
// Aligned to 2022 Texas TEKS §126.5
// 87 questions total

export const gradeKQuestions = [
  {
    id: "TA-K-CT-001",
    text: "You want to get ready for school in the morning. Which picture shows the BEST way to break this into smaller steps?",
    options: [
      { letter: 'A', text: "One big step, since breaking it up takes extra time", visual: "steps-one" },
      { letter: 'B', text: "Many small steps", visual: "steps-few" },
      { letter: 'C', text: "No steps, since figuring it out as you go is faster", visual: "steps-none" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-002",
    text: "You want to make a peanut butter and jelly sandwich. Which shows the right way to break it into pieces?",
    options: [
      { letter: 'A', text: "Get bread, spread PB, spread jelly, put together", visual: "steps-ordered" },
      { letter: 'B', text: "Just eat it right away, skipping all planning, since that's the first thing that makes sense to try", visual: "food-snack" },
      { letter: 'C', text: "Buy a pre-made sandwich from a store, since that seems like the easiest way", visual: "food-sandwich" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-003",
    text: "Your classroom is messy. What is the PROBLEM that needs to be solved?",
    options: [
      { letter: 'A', text: "The room needs to be cleaned up", visual: "checkmark" },
      { letter: 'B', text: "The room is too big, since that seems like the easiest way", visual: "face-confused" },
      { letter: 'C', text: "The room is too dark, since it usually works for simple problems", visual: "weather-dark" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-005",
    text: "Which big task can you break into smaller parts?",
    options: [
      { letter: 'A', text: "Blinking your eyes, since figuring it out as you go is faster", visual: "face-confused" },
      { letter: 'B', text: "Planting a garden", visual: "plant-seed" },
      { letter: 'C', text: "Taking one step, since breaking it up takes extra time", visual: "steps-one" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-006",
    text: "Look at this pattern: red, blue, red, blue, red, ___. What color comes next?",
    options: [
      { letter: 'A', text: "Green", visual: "color-green" },
      { letter: 'B', text: "Blue", visual: "color-blue" },
      { letter: 'C', text: "Yellow", visual: "color-yellow" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-007",
    text: "Look at this pattern: circle, square, circle, square, circle, ___. What shape comes next?",
    options: [
      { letter: 'A', text: "Triangle, since patterns sometimes skip or change", visual: "shape-triangle" },
      { letter: 'B', text: "Circle", visual: "shape-circle" },
      { letter: 'C', text: "Square", visual: "shape-square" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-008",
    text: "Every morning, the sun comes up. Every night, the sun goes down. What will happen tomorrow morning?",
    options: [
      { letter: 'A', text: "The sun will come up", visual: "weather-sun" },
      { letter: 'B', text: "It will stay dark, since that's the first thing that makes sense to try", visual: "weather-dark" },
      { letter: 'C', text: "The moon will stay out all day, since that seems like the easiest way", visual: "weather-moon" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-010",
    text: "Every Monday you go to the library. Today is Monday. What will you probably do today?",
    options: [
      { letter: 'A', text: "Go to the library", visual: "school-library" },
      { letter: 'B', text: "Go swimming at the pool instead, since it usually works for simple problems", visual: "swimming" },
      { letter: 'C', text: "Stay home and skip the library trip, since that's the first thing that makes sense to try", visual: "home-house" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-011",
    text: "What is an algorithm?",
    options: [
      { letter: 'A', text: "A type of snack, since skipping that step still works", visual: "food-snack" },
      { letter: 'B', text: "Step-by-step instructions", visual: "steps-ordered" },
      { letter: 'C', text: "A kind of animal, since the order doesn't seem to matter", visual: "animal-generic" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-012",
    text: "Which shows steps in the right order to wash your hands?",
    options: [
      { letter: 'A', text: "Dry, then wash, then turn on water, since it usually works for simple problems", visual: "x-wrong" },
      { letter: 'B', text: "Turn off water, then turn on water, then dry, since that's the first thing that makes sense to try", visual: "warning" },
      { letter: 'C', text: "Turn on water, add soap, scrub, rinse, dry", visual: "handwash" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-013",
    text: "You want to draw a picture. What comes FIRST?",
    options: [
      { letter: 'A', text: "Color it in, since that's the first thing that makes sense to try", visual: "art-drawing" },
      { letter: 'B', text: "Get paper and crayons", visual: "art-supplies" },
      { letter: 'C', text: "Show it to a friend, since that seems like the easiest way", visual: "person-share" }
    ],
    correctAnswer: "B",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-014",
    text: "FIRST get a cup, NEXT pour milk, THEN drink. What comes after 'pour milk'?",
    options: [
      { letter: 'A', text: "Get a cup, since that seems like the easiest way", visual: "cup-drink" },
      { letter: 'B', text: "Pour more milk, since it usually works for simple problems", visual: "food-snack" },
      { letter: 'C', text: "Drink", visual: "cup-drink" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-015",
    text: "Which word tells you something happens at the very END?",
    options: [
      { letter: 'A', text: "First", visual: "num-1" },
      { letter: 'B', text: "Next", visual: "steps-few" },
      { letter: 'C', text: "Last", visual: "checkmark" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-016",
    text: "A robot needs to get to a star. The star is 3 squares ahead. Which code gets the robot there?",
    options: [
      { letter: 'A', text: "Forward 3", visual: "robot-forward" },
      { letter: 'B', text: "Forward 1, since that's the first thing that makes sense to try", visual: "num-1" },
      { letter: 'C', text: "Turn around, since it usually works for simple problems", visual: "robot-wrong" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-017",
    text: "A character needs to go right then forward. Which set of blocks shows the right code?",
    options: [
      { letter: 'A', text: "Turn right, go forward", visual: "robot-forward" },
      { letter: 'B', text: "Go backward, turn left, since skipping that step still works", visual: "robot-wrong" },
      { letter: 'C', text: "Stop the program and do nothing, since the order doesn't seem to matter", visual: "stop" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-018",
    text: "You tell a friend to walk to the door: 'Walk 5 steps. Turn left. Walk 3 steps.' What did you just give your friend?",
    options: [
      { letter: 'A', text: "A code sequence — step-by-step directions", visual: "steps-ordered" },
      { letter: 'B', text: "A snack or type of food, not information, since that seems like the easiest way", visual: "food-snack" },
      { letter: 'C', text: "A question or verbal prompt, not a code sequence, since it usually works for simple problems", visual: "question" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-019",
    text: "A bug is in a maze. It needs to go: forward 2, turn right, forward 1 to reach the exit. What happens if it goes forward 2 and then turns LEFT instead?",
    options: [
      { letter: 'A', text: "It goes the wrong way", visual: "robot-wrong" },
      { letter: 'B', text: "It reaches the exit, since that error seems too small to matter", visual: "checkmark" },
      { letter: 'C', text: "It flies over the maze, since restarting usually fixes most problems", visual: "face-confused" }
    ],
    correctAnswer: "A",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CT-020",
    text: "Your teacher says: 'Stand up. Walk to the door. Touch the door. Walk back.' How many steps are in this code?",
    options: [
      { letter: 'A', text: "2", visual: "num-2" },
      { letter: 'B', text: "3", visual: "num-3" },
      { letter: 'C', text: "4", visual: "num-4" }
    ],
    correctAnswer: "C",
    strand: "Computational Thinking"
  },
  {
    id: "TA-K-CI-001",
    text: "Your teacher gives you 3 steps to draw a house. What should you do?",
    options: [
      { letter: 'A', text: "Follow the steps in order", visual: "checkmark" },
      { letter: 'B', text: "Draw whatever you want, since that seems like the easiest way", visual: "art-drawing" },
      { letter: 'C', text: "Skip all the steps, since that's the first thing that makes sense to try", visual: "x-wrong" }
    ],
    correctAnswer: "A",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-002",
    text: "The directions say: 'Click the blue button.' Which should you click?",
    options: [
      { letter: 'A', text: "The red button, since that seems like the easiest way", visual: "color-red" },
      { letter: 'B', text: "The green button, since that's the first thing that makes sense to try", visual: "color-green" },
      { letter: 'C', text: "The blue button", visual: "color-blue" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-003",
    text: "Why is it important to follow directions when using a computer?",
    options: [
      { letter: 'A', text: "So you can do the task the right way", visual: "checkmark" },
      { letter: 'B', text: "Directions never matter for any kind of task, since it usually works for simple problems", visual: "x-wrong" },
      { letter: 'C', text: "So the computer breaks or stops working, since that's the first thing that makes sense to try", visual: "device-computer" }
    ],
    correctAnswer: "A",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-004",
    text: "Your teacher says 'First save your work, then close the program.' What do you do first?",
    options: [
      { letter: 'A', text: "Close the program, since it usually works for simple problems", visual: "device-computer" },
      { letter: 'B', text: "Turn off the computer, since that's the first thing that makes sense to try", visual: "power-button-icon" },
      { letter: 'C', text: "Save your work", visual: "save-icon" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-005",
    text: "What happens if you DON'T follow the steps when building something?",
    options: [
      { letter: 'A', text: "It always works perfectly, since that's the first thing that makes sense to try", visual: "face-happy" },
      { letter: 'B', text: "It might not work or turn out right", visual: "warning" },
      { letter: 'C', text: "Directions are only for adults, since it usually works for simple problems", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-006",
    text: "Your class wants to make a card for a sick friend. What should you do FIRST?",
    options: [
      { letter: 'A', text: "Draw a random picture with no plan at all, since that seems like the easiest way", visual: "art-drawing" },
      { letter: 'B', text: "Ask questions like: What does our friend like? What should we say?", visual: "brainstorm-group" },
      { letter: 'C', text: "Throw the card away without making anything, since it usually works for simple problems", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-007",
    text: "What does 'brainstorm' mean?",
    options: [
      { letter: 'A', text: "A storm with rain and lightning, since the first try might work fine", visual: "weather-rain" },
      { letter: 'B', text: "Being quiet and not sharing, since testing takes too long", visual: "face-sad" },
      { letter: 'C', text: "Thinking of many ideas with your group", visual: "brainstorm-group" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-008",
    text: "You and your teacher are trying to make the reading corner better. What is a good first step?",
    options: [
      { letter: 'A', text: "Tear down the entire reading corner completely, since that's the first thing that makes sense to try", visual: "x-wrong" },
      { letter: 'B', text: "Leave it completely the same way forever, since that seems like the easiest way", visual: "face-confused" },
      { letter: 'C', text: "Look at it together and talk about what could be better", visual: "teamwork" }
    ],
    correctAnswer: "C",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-009",
    text: "A storyboard is a set of drawings that shows a plan. When would you use one?",
    options: [
      { letter: 'A', text: "To plan a project by drawing each step before starting", visual: "storyboard" },
      { letter: 'B', text: "To color a picture just for fun, since the first try might work fine", visual: "art-drawing" },
      { letter: 'C', text: "To write your spelling words, since testing takes too long", visual: "school-homework" }
    ],
    correctAnswer: "A",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-CI-010",
    text: "After you build something, your teacher asks 'Did it work? How can we make it better?' Why does the teacher ask this?",
    options: [
      { letter: 'A', text: "To help you think about how to improve it", visual: "design-improve" },
      { letter: 'B', text: "To make you feel bad, since it usually works for simple problems", visual: "face-sad" },
      { letter: 'C', text: "Because the teacher doesn't know the answer, since that's the first thing that makes sense to try", visual: "face-confused" }
    ],
    correctAnswer: "A",
    strand: "Creativity and Innovation"
  },
  {
    id: "TA-K-DL-001",
    text: "What is data?",
    options: [
      { letter: 'A', text: "A type of food or snack, not a device, since any chart type shows the same thing", visual: "food-snack" },
      { letter: 'B', text: "A game you play at recess, since more answers always give better results", visual: "playground" },
      { letter: 'C', text: "Information we collect about things — like how many, how tall, or what kind", visual: "data-collect" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-002",
    text: "Your class counts how many sunny days happen in a month. What are you collecting?",
    options: [
      { letter: 'A', text: "Clouds or cloud cover, since that's the first thing that makes sense to try", visual: "weather-cloud" },
      { letter: 'B', text: "Rain or rainfall data, since that seems like the easiest way", visual: "weather-rain" },
      { letter: 'C', text: "Data — information about the weather", visual: "data-collect" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-003",
    text: "Which of these is an example of collecting data?",
    options: [
      { letter: 'A', text: "Counting how many students are wearing red", visual: "data-collect" },
      { letter: 'B', text: "Taking a nap instead of working on the task, since more answers always give better results", visual: "face-happy" },
      { letter: 'C', text: "Eating lunch in the cafeteria at the table, since any chart type shows the same thing", visual: "food-snack" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-004",
    text: "You look at the sky every day and write down if it is sunny, cloudy, or rainy. What kind of information are you collecting?",
    options: [
      { letter: 'A', text: "Math homework, since it usually works for simple problems", visual: "school-homework" },
      { letter: 'B', text: "Spelling words, since that seems like the easiest way", visual: "school-book" },
      { letter: 'C', text: "Weather data", visual: "weather-cloud" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-005",
    text: "You ask each classmate their favorite color and make a list. What did you just do?",
    options: [
      { letter: 'A', text: "Played a game, since that seems like the easiest way", visual: "playground" },
      { letter: 'B', text: "Collected data about your classmates", visual: "data-collect" },
      { letter: 'C', text: "Wrote a story, since it usually works for simple problems", visual: "school-book" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-006",
    text: "You want to know what a penguin eats. Which device can help you search for the answer?",
    options: [
      { letter: 'A', text: "A pencil, since that seems like the easiest way", visual: "school-pencil" },
      { letter: 'B', text: "A tablet or computer", visual: "device-tablet" },
      { letter: 'C', text: "A jump rope, since that's the first thing that makes sense to try", visual: "playground" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-007",
    text: "Your teacher uses the computer to look up a video about dolphins. What is the computer doing?",
    options: [
      { letter: 'A', text: "Playing a game, since it usually works for simple problems", visual: "playground" },
      { letter: 'B', text: "Printing a picture, since that seems like the easiest way", visual: "device-printer" },
      { letter: 'C', text: "Searching for information", visual: "search-icon" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-008",
    text: "When your teacher finds a picture of a dinosaur online and shows it to you, what did the computer do?",
    options: [
      { letter: 'A', text: "Drew the picture by hand, since it usually works for simple problems", visual: "art-drawing" },
      { letter: 'B', text: "Retrieved (found and brought back) information from the internet", visual: "search-icon" },
      { letter: 'C', text: "Broke or corrupted the picture file completely, since that seems like the easiest way", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-009",
    text: "Which tool helps you search for information on a computer?",
    options: [
      { letter: 'A', text: "A search bar where you type words", visual: "search-icon" },
      { letter: 'B', text: "The power button — turns the device on or off, since that's the tool you already know", visual: "power-button-icon" },
      { letter: 'C', text: "The volume button — adjusts sound, not search, since it has the buttons you need", visual: "device-speaker" }
    ],
    correctAnswer: "A",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DL-010",
    text: "Can a tablet help you find out what the weather is like in another city?",
    options: [
      { letter: 'A', text: "No — tablets can only play games, since that seems like the easiest way", visual: "x-wrong" },
      { letter: 'B', text: "Only books can tell you about weather, since it usually works for simple problems", visual: "school-book" },
      { letter: 'C', text: "Yes — you can search for weather information", visual: "device-tablet" }
    ],
    correctAnswer: "C",
    strand: "Data Literacy"
  },
  {
    id: "TA-K-DC-001",
    text: "Which picture shows responsible behavior on a computer?",
    options: [
      { letter: 'A', text: "A student following the teacher's directions on the screen", visual: "checkmark" },
      { letter: 'B', text: "A student banging on the keyboard, since that seems like the easiest way", visual: "warning" },
      { letter: 'C', text: "A student throwing the mouse, since that's the first thing that makes sense to try", visual: "x-wrong" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-002",
    text: "What does it mean to be responsible when using a tablet?",
    options: [
      { letter: 'A', text: "Use it carefully and follow the rules", visual: "shield" },
      { letter: 'B', text: "Drop it on the floor, since it usually works for simple problems", visual: "warning" },
      { letter: 'C', text: "Hide it in your backpack, since that's the first thing that makes sense to try", visual: "school-backpack" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-003",
    text: "Your teacher says to go to a learning website. You see a fun game on a different site. What should you do?",
    options: [
      { letter: 'A', text: "Play the fun game on a different website, since it usually works for simple problems", visual: "playground" },
      { letter: 'B', text: "Close the computer and walk away, since that's the first thing that makes sense to try", visual: "device-computer" },
      { letter: 'C', text: "Stay on the website your teacher told you to use", visual: "checkmark" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-004",
    text: "Which is NOT responsible behavior when using technology?",
    options: [
      { letter: 'A', text: "Taking turns with the class tablet, since it usually works for simple problems", visual: "person-share" },
      { letter: 'B', text: "Asking a teacher for help when something is confusing, since that's the first thing that makes sense to try", visual: "person-teacher" },
      { letter: 'C', text: "Clicking on every pop-up ad you see", visual: "x-wrong" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-005",
    text: "After you finish using the class computer, what is the responsible thing to do?",
    options: [
      { letter: 'A', text: "Leave it messy for the next person, since it usually works for simple problems", visual: "warning" },
      { letter: 'B', text: "Break the headphones, since that seems like the easiest way", visual: "device-headphones" },
      { letter: 'C', text: "Log off and put things back neatly", visual: "checkmark" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-006",
    text: "Your school has rules about how to use computers. What are these rules called?",
    options: [
      { letter: 'A', text: "Math rules, since talking when it's not your turn seems minor", visual: "school-homework" },
      { letter: 'B', text: "Acceptable Use rules", visual: "shield" },
      { letter: 'C', text: "Recess rules, since that behavior doesn't bother anyone", visual: "playground" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-007",
    text: "The Acceptable Use rules say: only go to websites your teacher says are OK. Why?",
    options: [
      { letter: 'A', text: "To keep you safe while using the internet", visual: "shield" },
      { letter: 'B', text: "Because the teacher is mean, since talking when it's not your turn seems minor", visual: "face-sad" },
      { letter: 'C', text: "Because the computer only works on one website, since that behavior doesn't bother anyone", visual: "x-wrong" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-008",
    text: "Which follows the Acceptable Use rules?",
    options: [
      { letter: 'A', text: "Only visiting teacher-approved websites for learning", visual: "checkmark" },
      { letter: 'B', text: "Downloading games without asking, since talking when it's not your turn seems minor", visual: "x-wrong" },
      { letter: 'C', text: "Going to any website you want, since that behavior doesn't bother anyone", visual: "warning" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-009",
    text: "You find a website that has nothing to do with your schoolwork. What should you do?",
    options: [
      { letter: 'A', text: "Stay on it because it looks fun", visual: "playground" },
      { letter: 'B', text: "Close it and go back to your assignment", visual: "checkmark" },
      { letter: 'C', text: "Show it to everyone in class, since it usually works for simple problems", visual: "person-share" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-010",
    text: "What should you do if you are not sure if a website is OK to visit?",
    options: [
      { letter: 'A', text: "Visit it anyway, since that's the first thing that makes sense to try", visual: "warning" },
      { letter: 'B', text: "Ask your teacher before you click", visual: "person-teacher" },
      { letter: 'C', text: "Close the computer and don't use it, since that seems like the easiest way", visual: "device-computer" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-011",
    text: "Someone made a drawing and put it on the internet. Who owns that drawing?",
    options: [
      { letter: 'A', text: "Nobody — things on the internet belong to everyone, since it usually works for simple problems", visual: "face-confused" },
      { letter: 'B', text: "Whoever sees it first, since that seems like the easiest way", visual: "question" },
      { letter: 'C', text: "The person who made it", visual: "checkmark" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-012",
    text: "If you find a photo online, can you just say you took it?",
    options: [
      { letter: 'A', text: "Yes — anything online is yours, since it usually works for simple problems", visual: "x-wrong" },
      { letter: 'B', text: "No — someone else made it and it belongs to them, so you can't claim credit", visual: "checkmark" },
      { letter: 'C', text: "Only if it is pretty, since that's the first thing that makes sense to try", visual: "face-confused" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-013",
    text: "Your classmate writes a poem on the computer. Who owns that poem?",
    options: [
      { letter: 'A', text: "The computer hardware device, since it usually works for simple problems", visual: "device-computer" },
      { letter: 'B', text: "The teacher — but not the one who created it, since that seems like the easiest way", visual: "person-teacher" },
      { letter: 'C', text: "Your classmate — the person who wrote it", visual: "checkmark" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-014",
    text: "A song you hear on the computer was made by a musician. That means the musician _____ the song.",
    options: [
      { letter: 'A', text: "The musician forgot who made it, since it usually works for simple problems", visual: "face-confused" },
      { letter: 'B', text: "Owns", visual: "checkmark" },
      { letter: 'C', text: "The musician lost the song forever, since that's the first thing that makes sense to try", visual: "face-sad" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-015",
    text: "Why is it important to know that digital things have owners?",
    options: [
      { letter: 'A', text: "So we don't take credit for someone else's work", visual: "checkmark" },
      { letter: 'B', text: "It's not important or relevant to consider, since that's the first thing that makes sense to try", visual: "x-wrong" },
      { letter: 'C', text: "So we can delete their things, since that seems like the easiest way", visual: "warning" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-016",
    text: "Your friend asks to know your password. What should you say?",
    options: [
      { letter: 'A', text: "Sure, here it is — sharing it with anyone who asks, since it's easier to remember", visual: "x-wrong" },
      { letter: 'B', text: "No — passwords are private and should not be shared", visual: "lock" },
      { letter: 'C', text: "I forgot my password and can't remember it, since nobody else uses this account", visual: "face-confused" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-017",
    text: "You are done using the school computer. What should you do?",
    options: [
      { letter: 'A', text: "Walk away and leave it open, since that's the first thing that makes sense to try", visual: "warning" },
      { letter: 'B', text: "Log off your account", visual: "log-off-icon" },
      { letter: 'C', text: "Let someone else use your account, since that seems like the easiest way", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-018",
    text: "Who should know your school login password?",
    options: [
      { letter: 'A', text: "All your friends at school and online, since nobody else uses this account", visual: "person-share" },
      { letter: 'B', text: "Only you and a trusted adult like your teacher or parent", visual: "lock" },
      { letter: 'C', text: "The entire class of students, everyone, since it's easier to remember", visual: "brainstorm-group" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-019",
    text: "Why should you NOT share your password?",
    options: [
      { letter: 'A', text: "Because passwords are difficult to remember anyway, since it's easier to remember", visual: "face-confused" },
      { letter: 'B', text: "Because someone could get into your account and change or delete your work", visual: "warning" },
      { letter: 'C', text: "Passwords don't really matter for keeping accounts safe, since nobody else uses this account", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-020",
    text: "What happens if you DON'T log off the computer when you're done?",
    options: [
      { letter: 'A', text: "Nothing bad can ever happen from it, since it usually works for simple problems", visual: "face-happy" },
      { letter: 'B', text: "The computer will break or explode, since that's the first thing that makes sense to try", visual: "face-confused" },
      { letter: 'C', text: "Someone else might see or change your work", visual: "warning" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-021",
    text: "Which is SAFE to share online?",
    options: [
      { letter: 'A', text: "Your home address, since that's the first thing that makes sense to try", visual: "home-house" },
      { letter: 'B', text: "Your phone number, since that seems like the easiest way", visual: "warning" },
      { letter: 'C', text: "Your favorite color", visual: "color-blue" }
    ],
    correctAnswer: "C",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-022",
    text: "Which should you NEVER share with strangers online?",
    options: [
      { letter: 'A', text: "That you like dogs, since that's the first thing that makes sense to try", visual: "animal-dog" },
      { letter: 'B', text: "Your full name, school name, and address", visual: "x-wrong" },
      { letter: 'C', text: "That your favorite food is pizza, since it usually works for simple problems", visual: "food-pizza" }
    ],
    correctAnswer: "B",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-023",
    text: "Your teacher asks the class to share their favorite animal on a class blog. Is this safe?",
    options: [
      { letter: 'A', text: "Yes — sharing your favorite animal is safe", visual: "animal-generic" },
      { letter: 'B', text: "No — you should never share anything online, since it usually works for simple problems", visual: "x-wrong" },
      { letter: 'C', text: "Only if it's a cat, since that seems like the easiest way", visual: "animal-cat" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-024",
    text: "A game online asks for your birthday, full name, and phone number to create an account. What should you do?",
    options: [
      { letter: 'A', text: "Ask a parent or teacher for help — that is private information", visual: "person-teacher" },
      { letter: 'B', text: "Type it all in right away, since it's just one person you know", visual: "x-wrong" },
      { letter: 'C', text: "Make up a fake phone number to use, since they asked nicely", visual: "warning" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-DC-025",
    text: "Which list shows things that are SAFE to share online?",
    options: [
      { letter: 'A', text: "Favorite book, favorite sport, favorite color", visual: "school-book" },
      { letter: 'B', text: "Home address, password, phone number, since that's the first thing that makes sense to try", visual: "x-wrong" },
      { letter: 'C', text: "School name, teacher's name, classroom number, since that seems like the easiest way", visual: "warning" }
    ],
    correctAnswer: "A",
    strand: "Digital Citizenship"
  },
  {
    id: "TA-K-PT-001",
    text: "Which are different types of devices you can use for learning?",
    options: [
      { letter: 'A', text: "Tablet, computer, and phone", visual: "device-tablet" },
      { letter: 'B', text: "Fork, spoon, and plate, since it usually works for simple problems", visual: "wrong-items" },
      { letter: 'C', text: "Shoe, hat, and glove, since that's the first thing that makes sense to try", visual: "school-backpack" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-002",
    text: "An app on a tablet helps you practice math. What is an app?",
    options: [
      { letter: 'A', text: "A type of fruit or food, not a program, since that seems like the easiest way", visual: "food-fruit" },
      { letter: 'B', text: "The tablet device or screen hardware itself, since it usually works for simple problems", visual: "device-tablet" },
      { letter: 'C', text: "A program on a device that helps you do things like learn, draw, or read", visual: "app-tap" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-003",
    text: "Your class uses a learning website where you can watch videos and take quizzes. What is this called?",
    options: [
      { letter: 'A', text: "A playground or outdoor play space, since that's the first thing that makes sense to try", visual: "playground" },
      { letter: 'B', text: "An online learning environment", visual: "device-computer" },
      { letter: 'C', text: "A cafeteria or food area in school, since that seems like the easiest way", visual: "food-snack" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-004",
    text: "Your teacher says you can use a tablet OR a computer to practice reading today. Why is it good to use different devices?",
    options: [
      { letter: 'A', text: "It doesn't matter — they are all the same, since that's the first thing that makes sense to try", visual: "face-confused" },
      { letter: 'B', text: "Using different devices helps you learn to work with many types of technology", visual: "community-tech" },
      { letter: 'C', text: "You should only ever use one device, since that seems like the easiest way", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-005",
    text: "Which is an INPUT device — something you use to PUT information INTO a computer?",
    options: [
      { letter: 'A', text: "A keyboard", visual: "device-keyboard" },
      { letter: 'B', text: "A monitor (screen), since that's the tool you already know", visual: "device-monitor" },
      { letter: 'C', text: "A speaker, since it has the buttons you need", visual: "device-speaker" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-006",
    text: "Which is an OUTPUT device — something the computer uses to SHOW or GIVE you information?",
    options: [
      { letter: 'A', text: "A mouse — an input device, not for output, since it has the buttons you need", visual: "device-mouse" },
      { letter: 'B', text: "A keyboard — an input device, not an output, since that's the tool you already know", visual: "device-keyboard" },
      { letter: 'C', text: "A monitor (screen) that shows pictures and words", visual: "device-monitor" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-007",
    text: "Which is a piece of computer HARDWARE — a part you can touch?",
    options: [
      { letter: 'A', text: "A mouse", visual: "device-mouse" },
      { letter: 'B', text: "A drawing you made on screen, since that seems like the easiest way", visual: "art-drawing" },
      { letter: 'C', text: "The game you play on the computer, since that's the first thing that makes sense to try", visual: "playground" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-008",
    text: "What is SOFTWARE?",
    options: [
      { letter: 'A', text: "The parts of the computer you can touch, like the keyboard, since that's the first thing that makes sense to try", visual: "device-keyboard" },
      { letter: 'B', text: "Programs and apps that run on a computer — like games, drawing tools, and learning", visual: "app-tap" },
      { letter: 'C', text: "The wire that connects the computer to the wall, since that seems like the easiest way", visual: "device-computer" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-009",
    text: "A microphone lets you TALK to the computer. Is a microphone an input device or an output device?",
    options: [
      { letter: 'A', text: "Input — it puts your voice INTO the computer", visual: "device-microphone" },
      { letter: 'B', text: "Output — it plays sound OUT of the computer, since it has the buttons you need", visual: "device-speaker" },
      { letter: 'C', text: "It is not a device, since that's the tool you already know", visual: "x-wrong" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-010",
    text: "How do you OPEN an app on a tablet?",
    options: [
      { letter: 'A', text: "Shake the tablet, since it usually works for simple problems", visual: "x-wrong" },
      { letter: 'B', text: "Tap the app's icon on the screen", visual: "app-tap" },
      { letter: 'C', text: "Turn the tablet upside down, since that seems like the easiest way", visual: "face-confused" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-011",
    text: "You drew a picture on the computer. What should you do so you don't lose it?",
    options: [
      { letter: 'A', text: "Turn off the computer right away, since that's the first thing that makes sense to try", visual: "power-button-icon" },
      { letter: 'B', text: "Save it by clicking the save button", visual: "save-icon" },
      { letter: 'C', text: "Delete it, since it usually works for simple problems", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-012",
    text: "Your teacher says to print your work. What does PRINT mean on a computer?",
    options: [
      { letter: 'A', text: "The computer reads it out loud, since that seems like the easiest way", visual: "device-speaker" },
      { letter: 'B', text: "The computer automatically deletes your saved work, since it usually works for simple problems", visual: "x-wrong" },
      { letter: 'C', text: "The computer makes a paper copy of your work using a printer", visual: "device-printer" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-013",
    text: "You want to change the color of your digital drawing from blue to red. What are you doing?",
    options: [
      { letter: 'A', text: "Deleting the drawing, since that's the first thing that makes sense to try", visual: "x-wrong" },
      { letter: 'B', text: "Saving the drawing, since it usually works for simple problems", visual: "save-icon" },
      { letter: 'C', text: "Modifying (changing) the drawing", visual: "art-drawing" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-014",
    text: "Which button do you click to START a program on a computer?",
    options: [
      { letter: 'A', text: "The program's icon on the desktop or menu", visual: "app-tap" },
      { letter: 'B', text: "The power off button, since it has the buttons you need", visual: "power-button-icon" },
      { letter: 'C', text: "The volume button — adjusts sound, not search, since that's the tool you already know", visual: "device-speaker" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-015",
    text: "When you sit at a computer, how should your body be?",
    options: [
      { letter: 'A', text: "Slouching way down in the chair, since that seems like the easiest way", visual: "slouching" },
      { letter: 'B', text: "Sitting up straight with feet flat on the floor", visual: "sit-straight" },
      { letter: 'C', text: "Standing up on top of the chair to type, since it usually works for simple problems", visual: "warning" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-016",
    text: "Where should your hands be when you are ready to type?",
    options: [
      { letter: 'A', text: "On your lap while slouching down low, since that's the first thing that makes sense to try", visual: "face-confused" },
      { letter: 'B', text: "On the home row keys of the keyboard", visual: "hands-homerow" },
      { letter: 'C', text: "Held behind your back while trying to type, since that seems like the easiest way", visual: "x-wrong" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-017",
    text: "Why is it important to sit up straight when using a computer?",
    options: [
      { letter: 'A', text: "So you look nice for a photo, since that's the first thing that makes sense to try", visual: "face-happy" },
      { letter: 'B', text: "It's not important — sit however you want, since that seems like the easiest way", visual: "x-wrong" },
      { letter: 'C', text: "So your body doesn't get tired or sore from sitting the wrong way", visual: "sit-straight" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-018",
    text: "Where should your feet be when typing?",
    options: [
      { letter: 'A', text: "Flat on the floor", visual: "feet-flat" },
      { letter: 'B', text: "Up on the desk, since fewer fingers means fewer wrong keys", visual: "warning" },
      { letter: 'C', text: "Crossed under the chair, to type faster", visual: "slouching" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-019",
    text: "Look at the keyboard. Can you find the letter A?",
    options: [
      { letter: 'A', text: "It is on the second row of keys, on the left side", visual: "device-keyboard" },
      { letter: 'B', text: "It is not on the keyboard, to type faster", visual: "x-wrong" },
      { letter: 'C', text: "It is the biggest key at the bottom, since posture matters less than speed", visual: "key-spacebar" }
    ],
    correctAnswer: "A",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-020",
    text: "Where are the NUMBER keys on most keyboards?",
    options: [
      { letter: 'A', text: "On the very bottom row, to type faster", visual: "key-spacebar" },
      { letter: 'B', text: "On the back of the keyboard, since posture matters less than speed", visual: "x-wrong" },
      { letter: 'C', text: "Along the very top row of the keyboard", visual: "key-numbers-row" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-021",
    text: "Which key adds a SPACE between words when you type?",
    options: [
      { letter: 'A', text: "The Enter key — moves to a new line or confirms, since it usually works for simple problems", visual: "key-enter" },
      { letter: 'B', text: "The Backspace key — deletes the character before the cursor, since that's the first thing that makes sense to try", visual: "key-backspace" },
      { letter: 'C', text: "The Space bar — the long key at the bottom", visual: "key-spacebar" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-022",
    text: "You typed a wrong letter. Which key erases it?",
    options: [
      { letter: 'A', text: "The Space bar — adds a space between words, since that's the first thing that makes sense to try", visual: "key-spacebar" },
      { letter: 'B', text: "The Enter key — moves to a new line or confirms, since that seems like the easiest way", visual: "key-enter" },
      { letter: 'C', text: "The Backspace key — it deletes the letter before the cursor", visual: "key-backspace" }
    ],
    correctAnswer: "C",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-023",
    text: "Your teacher says: 'Type your name.' Which keys do you press?",
    options: [
      { letter: 'A', text: "The number keys, since that's the first thing that makes sense to try", visual: "key-numbers-row" },
      { letter: 'B', text: "The letter keys that spell your name", visual: "device-keyboard" },
      { letter: 'C', text: "The space bar over and over, since it usually works for simple problems", visual: "key-spacebar" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  },
  {
    id: "TA-K-PT-024",
    text: "The Enter key (also called Return) moves your cursor to a new line. Where is it usually found?",
    options: [
      { letter: 'A', text: "On the far left of the keyboard, since it usually works for simple problems", visual: "device-keyboard" },
      { letter: 'B', text: "On the right side of the keyboard, in the middle rows", visual: "key-enter" },
      { letter: 'C', text: "Under the keyboard, which is not where keys are, since that's the first thing that makes sense to try", visual: "face-confused" }
    ],
    correctAnswer: "B",
    strand: "Practical Technology"
  }
];
